exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deliverable__type__pause__icon{color:var(--wf-secondary);z-index:100;box-shadow:0 0 20px rgba(0,0,0,.1);height:20px;width:20px;border-radius:10px;position:absolute;margin-left:2rem;margin-top:.5rem}.deliverable__type__pause__icon i{font-size:.8rem;position:absolute;margin-left:.35rem;margin-top:.25rem}", ""]);

// exports
